import React, { Component } from 'react';
import FullScreenImage from '../../../../../../../../components/FullScreenImage';
// import Relay from 'react-relay/classic';

class ImageColumns extends Component {
  static styles = {};

  getVariantString = variant => (variant === 'four column' && 'fourcol')
    || (variant === 'three column' && 'threecol')
    || (variant === 'two column' && 'twocol');

  renderImages = item => (
    <figure className="figure-image">
      <FullScreenImage
        src={item.media.image.src}
        enableZoom={true}
        alt={item.media.alt || ''}
        placeHolder={item.media.image.placeHolder}
      />
    </figure>
  );

  render() {
    const { item, variant, editable, dispatch } = this.props;

    return (
      <div className="ImageColumnsContainer">
        <div className={'block-gallery block-gallery--' + this.getVariantString(variant)}>
          <div className="block-gallery__container">
            <div className="block-gallery__row">{this.renderImages(item, variant)}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ImageColumns;
